/* eslint-disable react/jsx-boolean-value */
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';

import ModalWrapper from 'components/Modals/ModalWrapper';
import { hideCustomerIdChangeFormError, getStorageSetting } from 'actions';
import { TextInput } from 'components/Common/Inputs/TextInput';
import AutoCompleteInput from 'components/Common/Inputs/AutoCompleteInput';
import { SelectInput } from 'components/Common/Inputs';

const editRequired = value => !value || !value.replace(/\s/g, '') || value.replace(/\s/g, '').length < 4;
const transferRequired = value => !value || !value.trim();

class CustomerIdChangeModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    selectedClient: PropTypes.shape({
      key: PropTypes.number,
      value: PropTypes.string
    }),
    isShown: PropTypes.bool.isRequired,
    onConfirmCustomerIdChange: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    id: PropTypes.number,
    customerId: PropTypes.string,
    isTempUser: PropTypes.bool
  };

  static defaultProps = {
    selectedClient: null,
    customerId: '',
    id: null,
    isTempUser: false
  };

  constructor(props) {
    super(props);
    const clients = getStorageSetting('clients') || [];

    this.state = {
      newCustomerId: '',
      confirmCustomerId: '',
      clientId: props.selectedClient != null ? props.selectedClient.key : null,
      legalEntity: null,
      clients,
      formErrors: null,
      customer: null,
      freeEntry: true
    };

    this.onDataInputChange = this.onDataInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  /* eslint-disable-next-line camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { isShown } = this.props;

    if (!isShown && nextProps.isShown) {
      this.setState({ freeEntry: true });
    }
  }

  onDataInputChange(event) {
    const { target: { name, value } } = event;
    this.setState({ [name]: value });
  }

  onClientChange = (e, newValue) => {
    this.setState({ clientId: parseInt(newValue, 10), legalEntity: null, customer: null });
  }

  onLegalEntitySelectedItem = (lookupValue) => {
    this.setState({ legalEntity: lookupValue, customer: null });
  }

  onLegalEntityChange = (e, newValue) => {
    this.setState({ legalEntity: null, customer: null });
  }

  onCustomerSelectedItem = (lookupValue) => {
    this.showCreateCustomer = false;
    const id = lookupValue.value.split(' - ')[0];
    this.setState({ customer: lookupValue, newCustomerId: id });
  }

  onCustomerChange = (e, newValue) => {
    const id = newValue.split(' - ')[0];
    this.setState({ newCustomerId: id });
  };

  fieldHasErrors(field) {
    const { formErrors } = this.state;
    return formErrors != null && formErrors.filter(error => error.field === field).length > 0;
  }

  handleSubmit(event) {
    const { onConfirmCustomerIdChange, id } = this.props;
    const { newCustomerId, confirmCustomerId, customer, freeEntry } = this.state;
    const updateDate = { id, newId: newCustomerId, confirmNewId: confirmCustomerId, transferCustomer: !freeEntry };

    event.preventDefault();

    if (freeEntry) {
      if (!newCustomerId.replace(/\s/g, '') || newCustomerId.replace(/\s/g, '').length < 4 || newCustomerId.replace(/\s/g, '').length > 100) {
        toastr.error('', 'Please provide a Customer ID between 4 and 100 characters long.');
        return;
      }

      if ((!newCustomerId || !confirmCustomerId || !newCustomerId.replace(/\s/g, '') || newCustomerId.replace(/\s/g, '').length < 4 || newCustomerId !== confirmCustomerId)) {
        toastr.error('', 'Please provide matching Customer ID and Confirm Customer ID.');
        return;
      }
    } else if (!customer || !customer.value) {
      toastr.error('', 'Please select a Customer ID from the list.');
      return;
    }

    onConfirmCustomerIdChange(updateDate);
    this.setState({ newCustomerId: '', confirmCustomerId: '' });
  }

  hideError() {
    const { dispatch } = this.props;
    dispatch(hideCustomerIdChangeFormError());
  }

  render() {
    const { isShown, onCancel, customerId, isTempUser, selectedClient } = this.props;
    const {
      newCustomerId,
      confirmCustomerId,
      clientId, legalEntity,
      clients,
      customer,
      freeEntry
    } = this.state;

    return (
      <ModalWrapper
        headerClose={ false }
        isOpen={ isShown }
        title="Change Customer ID"
        btnConfirmTitle="Confirm"
        btnCancelTitle="Cancel"
        onCancel={ onCancel }
        onConfirm={ this.handleSubmit }
        formId="customerIdChangeForm"
      >
        <div>
          <form className="form" id="customerIdChangeForm" name="customerIdChangeForm" onSubmit={ this.handleSubmit }>
            <div className="form-group">
              <div className="col-12">
                <p>
                  Please provide new Customer Id for Customer <span style={ { fontWeight: 'bold' } }>{ customerId }</span>
                </p>
              </div>
            </div>

            { isTempUser
            && <React.Fragment>
              <div onChange={ e => this.setState({ freeEntry: e.target.value === 'true' }) }>
                <label className="m-2">
                  <input className="m-2" type="radio" value name="freeEntry" defaultChecked={ freeEntry } />
                  Edit Customer ID
                </label>
                <label className="m-2">
                  <input className="m-2" type="radio" value={ false } name="freeEntry" defaultChecked={ !freeEntry } />
                  Transfer to Existing Customer
                </label>
              </div>
              <br />
            </React.Fragment>}

            { !freeEntry && isTempUser && <React.Fragment>
              <div className="form-group">
                <div className="col-4">
                  <label htmlFor="legal-entity-id" className="form-label m-2">Client</label>
                </div>
                <div className="col-8 col-sm-12">
                  <Field
                    id="client"
                    name="clientId"
                    component={ SelectInput }
                    className={ `form-select ${ this.fieldHasErrors('client') ? 'is-error m-2' : 'm-2' }` }
                    required
                    hideHints
                    disabled={ selectedClient != null }
                    value={ clientId }
                    validate={ transferRequired }
                    onChange={ (e, newValue) => this.onClientChange(e, newValue) }
                  >
                    <option value="" disabled>Choose a client</option>
                    { clients != null && clients.map(client => client != null && <option key={ client.key } value={ client.key }>{ client.value }</option>) }
                  </Field>
                </div>
              </div>
              <div className="form-group">
                <div className="col-4">
                  <label
                    htmlFor="legal-entity-id"
                    className="form-label m-2"
                  >
                    Legal Entity
                  </label>
                </div>
                <div className="col-8">
                  <AutoCompleteInput
                    id="legal-entity-id"
                    name="legalEntity"
                    category="legalentity"
                    context={ clientId != null ? { type: 'client', id: parseInt(clientId, 10), value: '' } : null }
                    placeholder="Enter legal entity name..."
                    className={ this.fieldHasErrors('legalEntity') ? 'is-error m-2' : 'm-2' }
                    value={ legalEntity || '' }
                    onSelectedItem={ lookupValue => this.onLegalEntitySelectedItem(lookupValue) }
                    onChange={ (e, newVal) => this.onLegalEntityChange(e, newVal) }
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="col-4">
                  <label
                    htmlFor="newId"
                    className="form-label m-2"
                  >
                    Customer ID
                  </label>
                </div>
                <div className="col-8">
                  <AutoCompleteInput
                    id="customer-id"
                    name="customerId"
                    category="customer"
                    context={ legalEntity }
                    placeholder="Enter Customer ID..."
                    className={ this.fieldHasErrors('customer') ? 'is-error m-2' : 'm-2' }
                    required
                    value={ customer || '' }
                    onSelectedItem={ lookupValue => this.onCustomerSelectedItem(lookupValue) }
                    onChange={ (e, newVal) => this.onCustomerChange(e, newVal) }
                  />
                </div>
              </div>
            </React.Fragment> }
            { freeEntry && <React.Fragment>
              <div className="form-group">
                <div className="col-4">
                  <label
                    htmlFor="newId"
                    className="form-label m-2"
                  >
                    New Customer ID
                  </label>
                </div>
                <div className="col-8">
                  <Field
                    id="newCustomerId"
                    name="newCustomerId"
                    component={ TextInput }
                    className="form-input m-2"
                    placeholder="Enter new customer ID"
                    required
                    value={ newCustomerId }
                    validate={ editRequired }
                    onChange={ this.onDataInputChange }
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="col-4">
                  <label
                    htmlFor="confirmCustomerId"
                    className="form-label m-2"
                  >
                    Confirm Customer ID
                  </label>
                </div>
                <div className="col-8">
                  <Field
                    id="confirmCustomerId"
                    name="confirmCustomerId"
                    component={ TextInput }
                    className="form-input m-2"
                    placeholder="Enter new customer ID"
                    required
                    value={ confirmCustomerId }
                    validate={ editRequired }
                    onChange={ this.onDataInputChange }
                  />
                </div>
              </div>
            </React.Fragment> }
          </form>
        </div>
      </ModalWrapper>
    );
  }
}

function mapStateToProps(state) {
  const {
    auth: {
      settings: {
        selectedClient
      }
    },
  } = state;

  return {
    selectedClient,
    initialValues: {
      clientId: selectedClient != null ? selectedClient.key.toString() : ''
    }
  };
}

export default connect(
  mapStateToProps
)(reduxForm({
  form: 'customerIdChangeForm'
})(CustomerIdChangeModal));
